//External
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "@shared/shared.module";
import { ModalWrapperModule } from "@shared/components/modal-wrapper/modal-wrapper.module";
import { PipesModule } from "src/app/shared/pipes/pipes.module";
import { GlobalDashboardComponent } from "./_containers/global-dashboard.component";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { KpiCardsModule } from "@shared/components/wpay-ui/kpi-cards/kpi-cards.module";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyCheckboxModule as MatCheckboxModule } from "@angular/material/legacy-checkbox";
import { InputWrapperModule } from "@shared/components/input-wrapper/input-wrapper.module";
import { InputSelectModule } from "@shared/components/input-select/input-select.module";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { FormsSharedModule } from "@shared/modules/forms-shared.module";
import { MatLegacyPaginatorModule as MatPaginatorModule } from "@angular/material/legacy-paginator";
import { MatLegacyTableModule as MatTableModule } from "@angular/material/legacy-table";
import { ToggleButtonModule } from "@shared/components/wpay-ui/toggle-button/toggle-button.module";
import { GlobalDashboardRoutingModule } from "./global-dashboard-routing.module";
import { WpayMultiSelectAutoCompleteModule } from "@shared/components/wpay-ui/base-components/wpay-multi-select-auto-complete/wpay-multi-select-auto-complete.module";

//Internal
import { FiltersContainerComponent } from "./_components/filters-container/filters-container.component";
import { LandingPageEventsTableComponent } from "./_components/tables/landing-page-events-table/landing-page-table.component";
import { MissingCardsTableComponent } from "./_components/tables/missing-cards-table/missing-cards-table.component";
import { FailedBeneficiariesTableComponent } from "./_components/tables/failed-beneficiaries-table/failed-beneficiaries-table.component";
import { MissingBankAccountsTableComponent } from "./_components/tables/missing-bank-accounts-table/missing-bank-accounts-table.component";
import { FailedTransactionsTableComponent } from "./_components/tables/failed-transactions-table/failed-transactions-table.component";
import { FailedPaymentOrdersTableComponent } from "./_components/tables/failed-payment-orders-table/failed-payment-orders-table.component";
import { LandingPageCustomerTableComponent } from "./_components/tables/landing-page-customer-table/landing-page-customer-table.component";
import { TableTopSectionComponent } from "./_components/table-top-section/table-top-section.component";
import { BreadcrumbsModule } from "@shared/components/breadcrumbs/breadcrumbs.module";
import { NoItemsLayoutModule } from "@shared/components/no-items-layout/no-items-layout.module";
import { WpayTextTruncateModule } from "@shared/components/wpay-ui/wpay-text-truncate/wpay-text-truncate.module";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";
import { TooltipModule } from "@shared/components/tooltip/tooltip.module";
import { MilestoneHistoryLogComponent } from "./_components/side-panels/milestone-events-history-log/milestone-history-log/milestone-history-log.component";
import { SlidingPanelModule } from "@shared/components/sliding-panel/sliding-panel.module";
import { MatDividerModule } from "@angular/material/divider";
import { LandingPagePaygroupTableComponent } from "./_components/tables/landing-page-paygroup-table/landing-page-paygroup-table.component";
import { HistoryLogSidePanelModule } from "@shared/components/history-log-side-panel/history-log-side-panel.module";
import { MilestoneStatusDropdownComponent } from "src/app/standalone/milestone-status-dropdown/milestone-status-dropdown.component";
import { CdkMenuModule } from "@angular/cdk/menu";
import { HideEventsDialogComponent } from "./_components/hide-events-dialog/hide-events-dialog.component";
import {
	MatLegacyDialogActions as MatDialogActions,
	MatLegacyDialogModule as MatDialogModule
} from "@angular/material/legacy-dialog";
import { HighlightAutomationComponent } from "./_components/highlight-automation/highlight-automation.component";
import { CalendarErrorsBannerComponent } from "src/app/standalone/calendar-errors-banner/calendar-errors-banner.component";

@NgModule({
	declarations: [
		GlobalDashboardComponent,
		FiltersContainerComponent,
		LandingPageEventsTableComponent,
		MissingCardsTableComponent,
		FailedBeneficiariesTableComponent,
		MissingBankAccountsTableComponent,
		FailedTransactionsTableComponent,
		FailedPaymentOrdersTableComponent,
		LandingPageCustomerTableComponent,
		TableTopSectionComponent,
		MilestoneHistoryLogComponent,
		LandingPagePaygroupTableComponent,
		HideEventsDialogComponent,
		HighlightAutomationComponent
	],
	imports: [
		CommonModule,
		SharedModule,
		ModalWrapperModule,
		PipesModule,
		KpiCardsModule,
		MatButtonModule,
		MatInputModule,
		InputWrapperModule,
		InputSelectModule,
		MatCheckboxModule,
		MatDatepickerModule,
		MatFormFieldModule,
		FormsSharedModule,
		MatPaginatorModule,
		MatTableModule,
		ToggleButtonModule,
		GlobalDashboardRoutingModule,
		WpayMultiSelectAutoCompleteModule,
		BreadcrumbsModule,
		NoItemsLayoutModule,
		WpayTextTruncateModule,
		MatTooltipModule,
		TooltipModule,
		BreadcrumbsModule,
		SlidingPanelModule,
		MatDividerModule,
		HistoryLogSidePanelModule,
		MilestoneStatusDropdownComponent,
		CdkMenuModule,
		MatDialogModule,
		CalendarErrorsBannerComponent
	],
	exports: [HighlightAutomationComponent]
})
export class GlobalDashboardModule {}
